import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=4e2e8c83&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"
import style0 from "./Emails.vue?vue&type=style&index=0&id=4e2e8c83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e8c83",
  null
  
)

export default component.exports